import * as ActionTypes from './actionTypes';
import BlitzAPI from './api/BlitzAPI';

export function updateProfile(params) {
  return {
    type: ActionTypes.UPDATE_PROFILE,
    params,
  };
}

function filterProfile(response) {
  return {
    fake_username: response.data.user.fake_username,
    username: response.data.user.username,
    name: response.data.user.name,
    email: response.data.user.email,
    admin: response.data.user.admin,
    token: response.data.token,
  };
}

export function logout() {
  return {
    type: ActionTypes.LOGOUT,
  };
}

export function login(userObj) {
  return (dispatch) => {
    return BlitzAPI.postLogin(userObj).then(
      (response) => {
        const profile = filterProfile(response.data);
        dispatch(updateProfile(profile));
      },
    )
  };
}



// WEBPACK FOOTER //
// ./src/actions.js